import React from 'react';
import { dispatch } from '@rematch/core';
import { Card, List, Button, Popup, Modal, Label } from 'semantic-ui-react';
import {
    Form
} from 'formsy-semantic-ui-react';

export default class APIKeys extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            selectedApiKeyId: null,
            formcyButtonDisabled: false,
            clientAppUrl: "",
            oauthDomain: "",
            isDirty: false
        }
    }

    componentWillMount() {
        dispatch.account.getAPIKeyDetails();
    }

    createAPiKey(org) {
        dispatch.account.createAPiKey({ accountId: org.accountId, organizationId: org._id });
    }

    copyData(org) {
        const el = document.createElement('textarea');
        el.value = `${org.organization[0].keyId}:${org.organization[0].keySecret}`;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

    setModalState(modalState) {
        this.setState({
            openModal: modalState
        });
    }

    updateStateValue(key,value){
        this.setState({
            [key]: value,
            isDirty: true
        });

    }

    openConfigModal(org) {
        this.setState({
            openModal: true,
            isDirty: false,
            selectedApiKeyId: org.organization[0]._id,
            clientAppUrl: org.organization[0] && org.organization[0].clientAppUrl ? org.organization[0].clientAppUrl : "",
            oauthDomain: org.organization[0] && org.organization[0].oauthDomain ? org.organization[0].oauthDomain : "",
        });
    }

    updateApiKeyDetails() {
        const { clientAppUrl,oauthDomain,selectedApiKeyId} = this.state; 
        const payLoad = {
            apiKeyId: selectedApiKeyId,
            clientAppUrl: clientAppUrl,
            oauthDomain: oauthDomain
        }
        dispatch.account.updateClientAppUrlDomainData(payLoad);
        this.setState({ openModal: false });
    }

    buttonDisabled = (e, flagValue) => {
        this.setState({ formcyButtonDisabled: flagValue });
    }

    render() {
        const { orgsWithAPIKeys } = this.props;
        const { openModal,clientAppUrl,oauthDomain} = this.state;

        const errorLabel = <div className="customErrorLabel" />;

        const thisObject = this;

        const getOrgWithKey = function (org, index) {
            return (
                <List.Item
                    className="singleLine categoryList" key={index}
                >
                    <List.Content floated='right' className="categoryIcon">
                        <Button.Group size='mini' className="mar_Right_5" >
                            <Popup
                                className="popupStyled"
                                inverted
                                trigger={
                                    <Button
                                        className="cursor-pointer"
                                        icon="key"
                                        onClick={() => thisObject.createAPiKey(org)}
                                        disabled={!(org.organization && org.organization.length === 0)}
                                    />
                                }
                                content='Generate Key'

                            />
                            <Button disabled={org.organization && org.organization.length === 0} onClick={() => thisObject.openConfigModal(org)} icon="cogs" />
                            <Popup
                                className="popupStyled"
                                inverted
                                trigger={
                                    <Button
                                        className="cursor-pointer"
                                        icon="copy"
                                        onClick={() => thisObject.copyData(org)}
                                        disabled={org.organization && org.organization.length === 0}
                                    />
                                }
                                content='Copy Key'

                            />
                        </Button.Group>
                    </List.Content>
                    <List.Content className="categoryName">
                        <List.Header >
                            {org.name}
                        </List.Header>
                    </List.Content>
                </List.Item>
            )
        }

        return (
            <div className="general-setting">
                <Card>
                    <Card.Header>API Keys</Card.Header>
                    <Card.Content className="pad_0">
                        <List divided verticalAlign='middle' >
                            {orgsWithAPIKeys ?
                                orgsWithAPIKeys.map((org, index) => {
                                    return getOrgWithKey(org, index);
                                }) : null}
                        </List>
                    </Card.Content>
                </Card>
                <Modal
                    open={openModal}
                    className="basicModal"
                    size='tiny'
                    closeOnEscape={false}
                    closeOnDimmerClick={false}
                    closeIcon
                    onClose={() => thisObject.setModalState(false)}
                >
                    <Modal.Header>Configuration - Custom UI Application</Modal.Header>
                    <Modal.Content>
                        <Form noValidate
                            ref={ref => this.form = ref}
                            className="formcyForm"
                            onValid={(e) => this.buttonDisabled(e, true)}
                            onInvalid={(e) => this.buttonDisabled(e, false)}
                            onValidSubmit={(e) => { this.props.submitTextModal(e) }}
                        >

                            <Form.Input
                                required
                                name="appUrl"
                                id="appUrl"
                                label="Application URL"
                                value={ clientAppUrl ? clientAppUrl : ""}
                                placeholder=""
                                validations="isUrl"
                                validationErrors={{
                                    isUrl: 'Requires a valid URL starting with http:// or https://'
                                }}
                                onChange={event => this.updateStateValue("clientAppUrl",event.target.value)} 
                                errorLabel={errorLabel}
                                instantValidation
                                autoFocus={true}
                            />

                            <Form.Input
                                required
                                name="oauthId"
                                id="oauthId"
                                label="OAuth Domain"
                                value={ oauthDomain ? oauthDomain : ""}
                                placeholder=""
                                validationErrors={{
                                    isDefaultRequiredValue: `OAuth domain is required`,
                                }}
                                onChange={ event => this.updateStateValue("oauthDomain",event.target.value)}
                                instantValidation
                            />

                            <br />
                          
                            <div className="pull-right" style={{ "marginBottom": "25px" }}>
                                <Button content='Cancel' className="button-cancel" type="button" onClick={() => thisObject.setModalState(false)} />
                                <Button disabled={ !(thisObject.state.isDirty && thisObject.state.formcyButtonDisabled)} onClick={() => thisObject.updateApiKeyDetails()} type="submit" content='Update' className="button-submit" />
                            </div>
                        </Form >

                    </Modal.Content>
                </Modal>
            </div>);
    }

}
